import React from "react";
import MatchStatus from "./MatchStatus";

const MatchesTable = ({ matches = [], teams, group }) => {
  // Group matches by round
  const matchesByRound = {};
  matches.forEach((match) => {
    const round = match.round || "Khác";
    if (!matchesByRound[round]) {
      matchesByRound[round] = [];
    }
    matchesByRound[round].push(match);
  });

  // Sort rounds
  const sortedRounds = Object.keys(matchesByRound).sort((a, b) => {
    if (a === "Khác") return 1;
    if (b === "Khác") return -1;
    return a - b;
  });

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 text-blue-700">
        Trận đấu - Bảng {group}
      </h3>

      {sortedRounds.map((round) => (
        <div key={`round-${round}`} className="mb-6">
          <h4 className="font-medium text-gray-700 mb-2 border-b pb-1">
            {round === "Khác" ? "Các trận khác" : `Vòng ${round}`}
          </h4>

          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border shadow-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                    Thời gian
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Vòng
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Sân
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Đội 1
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    VĐV
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Điểm
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Đội 2
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    VĐV
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Điểm
                  </th>
                  <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Trạng thái
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {matchesByRound[round].map((match) => {
                  const team1Data = teams.find(
                    (team) => team.id === match.team1
                  );
                  const team2Data = teams.find(
                    (team) => team.id === match.team2
                  );
                  const isTeam1Winner = match.winner === match.team1;
                  const isTeam2Winner = match.winner === match.team2;

                  // Tách điểm thành mảng nếu có nhiều set
                  // const scores = match.score
                  //   ? match.score.split(",").map((s) => s.trim())
                  //   : ["", ""];
                  const scores1 = match.score1
                    ? match.score1.split(",").map((s) => s.trim())
                    : ["", ""];
                  const scores2 = match.score2
                    ? match.score2.split(",").map((s) => s.trim())
                    : ["", ""];
                  const team1Score =
                    match.status !== "Scheduled"
                      ? scores1.map((s) => s.split("-")[0]).join(", ")
                      : "";
                  const team2Score =
                    match.status !== "Scheduled"
                      ? scores2.map((s) => s.split("-")[0]).join(", ")
                      : "";

                  return (
                    <tr key={match.id} className="hover:bg-gray-50">
                      <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500 text-left">
                        {match.time}
                      </td>
                      <td className="px-2 py-3 whitespace-nowrap text-sm text-center">
                        <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded">
                          {round}
                        </span>
                      </td>
                      <td className="px-2 py-3 whitespace-nowrap text-sm text-center text-gray-500">
                        {match.court}
                      </td>
                      <td
                        className={`px-2 py-3 whitespace-nowrap text-sm font-medium text-center ${
                          isTeam1Winner
                            ? "font-bold text-blue-700"
                            : "text-gray-900"
                        }`}
                      >
                        {team1Data?.id}
                      </td>
                      <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                        {team1Data?.player1} & {team1Data?.player2}
                      </td>
                      <td
                        className={`px-2 py-3 whitespace-nowrap text-sm font-medium text-center ${
                          isTeam1Winner ? "text-blue-700" : "text-gray-900"
                        }`}
                      >
                        {team1Score}
                      </td>
                      <td
                        className={`px-2 py-3 whitespace-nowrap text-sm font-medium text-center ${
                          isTeam2Winner
                            ? "font-bold text-blue-700"
                            : "text-gray-900"
                        }`}
                      >
                        {team2Data?.id}
                      </td>
                      <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                        {team2Data?.player1} & {team2Data?.player2}
                      </td>
                      <td
                        className={`px-2 py-3 whitespace-nowrap text-sm font-medium text-center ${
                          isTeam2Winner ? "text-blue-700" : "text-gray-900"
                        }`}
                      >
                        {team2Score}
                      </td>
                      <td className="px-2 py-3 whitespace-nowrap text-center">
                        <MatchStatus status={match.status} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MatchesTable;
